// extracted by mini-css-extract-plugin
export default {"MenuItem__container":"MenuItem_MenuItem__container__aKeOX"};